import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Logo from "~/shared/ui/brand/Logo";
import { COLORS } from "~/ui/tokens";

export function AuthCard({ children, maxWidth = 420, embedded = false }) {
  const card = (
    <Paper elevation={embedded ? 1 : 6} sx={{ width: "100%", maxWidth, p: { xs: 3, sm: 5 }, textAlign: "center", borderRadius: 2 }}>
      {children}
    </Paper>
  );
  if (embedded) return <Box sx={{ display: "flex", justifyContent: "center", p: { xs: 2, md: 6 } }}>{card}</Box>;
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        background: `linear-gradient(135deg, ${COLORS.primary} 0%, #1d5a78 55%, #0b7fa0 100%)`,
      }}
    >
      {card}
    </Box>
  );
}

export function AuthBrand() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      <Typography component="h1" sx={{ m: 0, lineHeight: 0 }}>
        <Logo variant="stacked" tagline width={230} />
      </Typography>
      <Typography sx={{ color: COLORS.muted }}>Painel Antecipe Pagamentos</Typography>
    </Box>
  );
}

export default AuthCard;
